import axios from 'axios';
import { EventBus } from "@/event-bus";

export class RequestTools {

    constructor() {

        //TODO: colocar no arquivo de config e remover do main
        this._appMessages = {
            "err404": "Acesso não autorizado!",
            "loginInvalid": "Não foi possível efetuar o login, confirme seu nome de usuário e senha"
        };
    }

    async requestGet(url) {
        const response = await axios.get(this._parseUrl(url), axios.getHeaders()).catch((err) => {
            return this._parseCatch(err, this._appMessages.err404);
        });

        if (!response) {
            return null;
        }

        return response.data;
    }

    _parseUrl(url) {
        if (url.indexOf(process.env.VUE_APP_ROOT_API) === -1) {
            url = process.env.VUE_APP_ROOT_API + url;
        }
        return url;
    }

    _parseCatch(err = null, msg404 = "Erro 404") {

        console.log("parseCatch: ", err);

        if (!err.response) {
            console.warn("Não há resposta: ", err);
            return;
        }

        if (!err.response.status) {
            console.warn("Não há status: ", err);
            return;
        }

        if (404 === parseInt(err.response.status)) {

            if (msg404) {
                console.warn("Não há status: ", msg404);
                EventBus.$emit("toast", {tx: msg404});
            }

            EventBus.$emit("goto_login");
    }

    }
}